import loadable from '@loadable/component';
import Spinner from '../../components/Spins/Basic';

export default loadable(() => import('./index'), {
  LoadingComponent: Spinner,
});
